module.exports = __webpack_public_path__ + "img/item_dr.07693e63.png";